"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleGalleryInfoModal = TitleGalleryInfoModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
function TitleGalleryInfoModal({ isOpen, closeModal }) {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsxs)(elements_1.Modal, { title: intl.formatMessage({ id: 'admin.offer.assets.title_gallery_modal.title' }), visible: isOpen, onOk: closeModal, onCancel: closeModal, children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer.assets.title_gallery_modal.description", values: {
                    strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
                } }), (0, jsx_runtime_1.jsx)("div", { className: "m-t-m m-b-m", children: (0, jsx_runtime_1.jsx)("img", { className: "width-100", src: "https://static.wixstatic.com/media/bb1bd6_675b209fdea945bbb7428cb91186b4cd~mv2.gif", alt: "title-gallery-gif" }) })] }));
}
